module.exports = __webpack_public_path__ + "img/jpg.a28ad66b.svg";